import { APP_INITIALIZER, NgModule } from '@angular/core';
import { MAT_MOMENT_DATE_FORMATS, MatMomentDateModule } from "@angular/material-moment-adapter";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { FuseModule } from '@fuse';
import { FuseMockApiModule } from '@fuse/lib/mock-api';
import { FuseConfigModule } from '@fuse/services/config';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { appConfig } from 'app/core/config/app.config';
import { CoreModule } from 'app/core/core.module';
import { LayoutModule } from 'app/layout/layout.module';
import { mockApiServices } from 'app/mock-api';

import { registerLocaleData } from '@angular/common';
import localeEsCo from '@angular/common/locales/es-CO';
import { configInitializer } from '@core/config/app.config.initializer';
import { ConfigService } from '@core/config/app.config.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EffectsModule } from '@ngrx/effects';
import { ActionReducer, MetaReducer, StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StateStorageService } from '@shared/services/apl-afiliacion/store/store.service';
import { ROOT_REDUCERS } from './store/app.state';
import { ServiciosExternosEffects } from './store/effects/servicios-externos.effects';
import { clearStateMetaReducer } from './store/reducers/clear-store.metareducer';
registerLocaleData(localeEsCo)

const routerConfig: ExtraOptions = {
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
    bindToComponentInputs: true,
    useHash: true,
    onSameUrlNavigation: 'reload'
};

const MY_DATE_FORMATS = {
    parse: {
        dateInput: 'DD/MM/YYYY',
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

export function hydrationMetaReducer(reducer: ActionReducer<any>): ActionReducer<any> {
    return function(state, action) {
        const storageService = new StateStorageService();
        const savedState = storageService.loadState();
        const nextState = savedState ? { ...state, ...savedState } : state;
        const newState = reducer(nextState, action);
        storageService.saveState(newState);
        return newState;
    };
}

const metaReducers: MetaReducer<any>[] = [hydrationMetaReducer, clearStateMetaReducer];

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),

        // Fuse, FuseConfig & FuseMockAPI
        FuseModule,
        FuseConfigModule.forRoot(appConfig),
        FuseMockApiModule.forRoot(mockApiServices),

        // Core module of your application
        CoreModule,

        // Layout module of your application
        LayoutModule,

        MatNativeDateModule,
        MatMomentDateModule,
        MatDatepickerModule,
        MatTooltipModule,
        StoreModule.forRoot(ROOT_REDUCERS, { metaReducers }),
        StoreDevtoolsModule.instrument({ name: 'TEST' }),
        EffectsModule.forRoot([ServiciosExternosEffects]),
        NgbModule
    ],
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: configInitializer,
            multi: true,
            deps: [ConfigService]
        },
        {
            provide: MAT_MOMENT_DATE_FORMATS,
            useValue: MY_DATE_FORMATS
        }
    ],
    bootstrap: [AppComponent],
})
export class AppModule { }
